<template>
  <section class="page-index">
    <!-- s 页面1 -->
    <div class="page01">
      <!-- 声音 -->
      <v-sound :type="'yellow'"></v-sound>

      <!-- 动画 -->
      <div class="cont-move">
        <!-- 屋檐 -->
        <div class="eaves"></div>
        <!-- 烟花 -->
        <div class="fireworks"></div>
        <div class="firecracker"></div>
        <div class="fireworks fireworks2"></div>
        <div class="firecracker firecracker2"></div>
        <!-- 灯笼 -->
        <div class="lantern lantern-left"></div>
        <!-- 灯笼 -->
        <div class="lantern lantern-right"></div>

        <!-- 星星 -->
        <div class="star star1"></div>
        <div class="star star2"></div>
        <div class="star star3"></div>
        <div class="star star4"></div>

        <!-- 热气 -->
        <div class="heat">
          <div class="arr arr01"></div>
          <div class="arr arr02"></div>
        </div>
        <div class="heat heat1">
          <div class="arr arr01"></div>
          <div class="arr arr02"></div>
        </div>
        <div class="heat heat2">
          <div class="arr arr01"></div>
          <div class="arr arr02"></div>
        </div>
        <div class="heat heat3">
          <div class="arr arr01"></div>
          <div class="arr arr02"></div>
        </div>
        <div class="heat heat4">
          <div class="arr arr01"></div>
          <div class="arr arr02"></div>
        </div>
        <div class="heat heat5">
          <div class="arr arr01"></div>
          <div class="arr arr02"></div>
        </div>
        <div class="heat heat6">
          <div class="arr arr01"></div>
          <div class="arr arr02"></div>
        </div>
        <div class="heat heat7">
          <div class="arr arr01"></div>
          <div class="arr arr02"></div>
        </div>
      </div>

      <!-- 底部按钮 -->
      <div class="foot-bar">
        <div class="btn" @click="handleJumpPage">立即参与</div>
        <div v-if="!$route.params.id || $route.params.id == 0" class="text">
          <p class="t1">主办单位</p>
          <p class="t2">
            新探健康发展研究中心&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;北京健康教育协会
          </p>
        </div>
        <div v-else-if="$route.params.id == 3" class="text">
          <p class="t1">主办单位</p>
          <p v-for="(item, index) in contName" :key="index" class="t2">
            {{ item }}
          </p>
          <p class="t2">
            新探健康发展研究中心&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;北京健康教育协会
          </p>
        </div>
        <div v-else class="text">
          <p class="t2">
            新探健康发展研究中心&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;北京健康教育协会
          </p>
          <p v-for="(item, index) in contName" :key="index" class="t2">
            {{ item }}
          </p>
        </div>
      </div>
    </div>
    <!-- end 页面1 -->
    <!-- 分享 -->
    <v-share ref="share" :shareData="shareData"></v-share>
  </section>
</template>

<script>
import pageMixins from "../mixins/page-mixins";
import VSound from "../components/v-sound.vue";
import VShare from "../components/share/v-share.vue";
// import { getQuery } from "../utils/url";
import { comData } from "../utils/com_data";

export default {
  mixins: [pageMixins],
  components: { VSound, VShare },

  data() {
    return {
      // 分享参数
      shareData: {},
      // url单位名称
      contName: "",
    };
  },
  props: ["id"],
  computed: {},

  mounted() {
    // 初始化分享
    this.initShare();

    console.log("this.id", this.id);
    console.log("this.$route.params.id", this.$route.params.id);
    this.comName(this.$route.params.id);
  },

  methods: {
    // 获取名称
    comName(id) {
      const item = comData.find((item) => item.id == id);
      this.contName = item ? item.name : null;
    },

    // 初始化分享
    initShare() {
      let link = "";
      if (this.$route.params.id) {
        link = `http://www.szdsee.com/xintan2024/#/index/${this.$route.params.id}`;
      } else {
        link = `http://www.szdsee.com/xintan2024/#/index`;
      }
      this.shareData = {
        title: "过新年选好礼 卷烟不宜做礼品",
        desc: "春节应送健康礼 过节送礼不送烟 健康快乐过大年",
        imgUrl: "http://www.szdsee.com/xintan2024/wx-share.jpg",
        link,
      };
      // 设置wx分享参数;
      this.$nextTick(() => {
        this.$refs.share.shareInitData(this.shareData);
      });
    },

    // 跳转到文字页
    handleJumpPage() {
      let link = "";
      if (this.$route.params.id) {
        link = `/text/${this.$route.params.id}`;
      } else {
        link = "/text";
      }
      this.$router.push({
        path: link,
      });
    },
  },
};
</script>

<style lang="less">
.page-index {
  // 页面1
  .page01 {
    position: relative;
    background-image: url("../assets/image/home-bg01.jpg");
    background-size: 100% auto;
    background-repeat: no-repeat;
    min-height: 100vh;
    .foot-bar {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      padding-bottom: 15px;
      .btn {
        width: 654px;
        height: 245px;
        margin: 0 auto;
        background-image: url("../assets/image/home-btn.png");
        background-size: 100% 100%;
        text-indent: -9999px;
      }
      .text {
        margin-top: -30px;
        text-align: center;
        font-weight: 700;
        color: #ad4229;
        text-shadow: 0 0 10px #fff, 0 0 10px #fff, 0 0 10px #fff, 0 0 10px #fff;
        .t1 {
          margin-top: -50px;
          font-size: 52px;
        }
        .t2 {
          margin-bottom: 5px;
          font-size: 44px;
        }
      }
    }

    .cont-move {
      // 屋檐
      .eaves {
        position: absolute;
        top: 490px;
        left: 0;
        z-index: 40;
        width: 100%;
        height: 383px;
        background-image: url("../assets/image/home-icon01.png");
        background-size: 100% 100%;
      }
      // 灯笼
      .lantern {
        position: absolute;
        z-index: 30;
      }
      .lantern-left {
        top: 725px;
        left: 100px;
        width: 382px;
        height: 393px;
        background-image: url("../assets/image/home-lantern-left.png");
        background-size: 100% 100%;
        animation: swinging 3.6s infinite ease-in-out;
        transform-origin: top center;
      }
      .lantern-right {
        top: 762px;
        left: 680px;
        width: 310px;
        height: 339px;
        background-image: url("../assets/image/home-lantern-right.png");
        background-size: 100% 100%;
        animation: swinging 4.2s infinite ease-in-out;
        transform-origin: top center;
      }
      // 星星
      .star {
        position: absolute;
        z-index: 40;
        top: 100px;
        right: 300px;
        width: 22px;
        height: 22px;
        background-image: url("../assets/image/home-star.png");
        background-size: 100% 100%;
      }
      .star1 {
        top: 220px;
        right: 10px;
        width: 42px;
        height: 42px;
        animation: twinkling 2s infinite;
      }
      .star2 {
        top: 100px;
        right: 200px;
        width: 32px;
        height: 32px;
        animation: twinkling 1s infinite;
      }
      .star3 {
        top: 120px;
        right: 400px;
        width: 22px;
        height: 22px;
        animation: twinkling 3s infinite;
      }
      .star4 {
        top: 160px;
        left: 130px;
        width: 22px;
        height: 22px;
        animation: twinkling 1s infinite;
      }

      // 热气
      .heat {
        position: absolute;
        z-index: 40;
        top: 1150px;
        left: 268px;
        width: 10px;
        height: 10px;
        .arr01 {
          position: absolute;
          bottom: 0;
          left: 0;
          width: 50px;
          height: 73px;
          background-image: url("../assets/image/home-heat01.png");
          background-size: 100% 100%;
          animation: rising 2s infinite;
          animation-delay: -1s;
        }
        .arr02 {
          position: absolute;
          bottom: 0;
          left: 30px;
          width: 33px;
          height: 53px;
          background-image: url("../assets/image/home-heat02.png");
          background-size: 100% 100%;
          animation: rising 2s infinite;
        }
      }
      .heat1 {
        top: 1150px;
        left: 268px;
      }
      .heat2 {
        top: 1290px;
        left: 346px;
      }
      .heat3 {
        top: 1260px;
        left: 460px;
        .arr01 {
          animation-delay: -1s;
        }
        .arr02 {
          animation-delay: -2s;
        }
      }
      .heat4 {
        top: 1300px;
        left: 500px;
        .arr01 {
          animation-delay: -0.3s;
        }
        .arr02 {
          animation-delay: -0.6s;
        }
      }
      .heat5 {
        top: 1250px;
        left: 580px;
        .arr01 {
          animation-delay: -0.2s;
        }
        .arr02 {
          animation-delay: -0.5s;
        }
      }
      .heat6 {
        top: 1310px;
        left: 670px;
        .arr01 {
          animation-delay: -0.8s;
        }
        .arr02 {
          animation-delay: -0.2s;
        }
      }
      .heat7 {
        top: 1350px;
        left: 580px;
        .arr01 {
          animation-delay: -0.3s;
        }
        .arr02 {
          animation-delay: -0.2s;
        }
      }

      .fireworks {
        position: absolute;
        left: 550px;
        top: 50px;
        transform: scale(0);
        animation: fireworks 5s infinite;
        z-index: 60;
        width: 145px;
        height: 134px;
        background-image: url("../assets/image/home-fireworks.png");
        background-size: 100% 100%;
      }

      .firecracker {
        position: absolute;
        left: 620px;
        top: 50px;
        animation: firecracker 5s infinite;
        width: 18px;
        height: 51px;
        background-image: url("../assets/image/home-firecracker.png");
        background-size: 100% 100%;
      }

      .fireworks2 {
        left: 250px;
        top: 70px;
        animation-delay: -1.5s;
      }
      .firecracker2 {
        left: 320px;
        top: 70px;
        animation-delay: -1.5s;
      }
    }
  }

  // 烟花
  @keyframes fireworks {
    0% {
      transform: scale(0);
    }
    50% {
      opacity: 1;
      transform: scale(0);
    }
    80% {
      transform: scale(1);
    }
    100% {
      opacity: 0;
    }
  }

  @keyframes firecracker {
    0% {
      transform: scale(1);
      top: 200px;
    }
    70% {
      top: 80px;
      transform: scale(0);
    }
    100% {
      top: 80px;
      transform: scale(0);
    }
  }

  // 星星效果
  @keyframes twinkling {
    0% {
      opacity: 0.3;
    }
    50% {
      opacity: 1;
    }
    100% {
      opacity: 0.3;
    }
  }

  // 灯笼效果
  @keyframes swinging {
    0% {
      transform: rotate(-12deg);
    }
    50% {
      transform: rotate(12deg);
    }
    100% {
      transform: rotate(-12deg);
    }
  }

  // 烟
  // .heat {
  //   position: relative;
  //   top: 300px;
  //   left: 300px;
  //   width: 100px;
  //   height: 100px;
  //   background: red;
  // }

  // .heat::before,
  // .heat::after {
  //   content: "";
  //   position: absolute;
  //   bottom: 100%;
  //   width: 50px;
  //   height: 50px;
  //   border-radius: 50%;
  //   background: rgba(255, 255, 255, 0.5);
  //   animation: rising 2s infinite;
  // }

  // .heat::before {
  //   left: 0;
  //   animation-delay: -1s;
  // }

  // .heat::after {
  //   right: 0;
  // }

  @keyframes rising {
    0% {
      bottom: 100%;
      transform: scale(0);
    }
    50% {
      transform: scale(1);
    }
    100% {
      bottom: 200%;
      transform: scale(0);
    }
  }
}
</style>
